import { render, staticRenderFns } from "./grapejs.vue?vue&type=template&id=243deab8"
import script from "./grapejs.vue?vue&type=script&lang=js"
export * from "./grapejs.vue?vue&type=script&lang=js"
import style0 from "./grapejs.vue?vue&type=style&index=0&id=243deab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports